<section class="container">
  <digital-platform-breadcrumbs
    [nestedBreadcrumbItem]="breadcrumbs"
  ></digital-platform-breadcrumbs>
  <div class="card border-0 ms-0 ms-xl-6 rounded-0 rounded-bottom">
    <div class="card-body bg-white p-0 p-xl-7">
      <div class="header">
        <h4 class="me-10 card-title mb-6">
          Find an Environmental Solutions Facility
        </h4>
        <div
          class="service-badge-container d-flex justify-content-between mb-6 align-items-start"
        >
          <div
            class="service-badges d-flex flex-wrap align-items-center"
            #serviceBadges
          >
            <span
              *ngFor="let serviceName of selectedServiceNames"
              class="badge text-container-blue fw-normal bg-cloud-blue m-3 justify-content-center align-items-center d-inline-flex fs-9"
            >
              {{ serviceName }}</span
            >
          </div>
          <a
            role="button"
            class="clear-filter-btn text-container-blue text-nowrap small fw-semibold text-decoration-none"
            *ngIf="selectedServiceNames.length > 0"
            (click)="clearFilters(facilityFilterService)"
            >Clear Filters</a
          >
        </div>
        <div
          class="d-none d-xl-block mb-6 small fw-semibold"
          style="color: #b0b1b4"
        >
          <a
            role="button"
            class="browse-location-options text-container-blue text-nowrap text-decoration-none"
            data-automation-id="link-browse-by-state"
            (click)="scrollTo('browse-states')"
          >
            <span>Browse Facilities By State</span>
          </a>
          |
          <a
            role="button"
            class="browse-location-options text-container-blue text-nowrap text-decoration-none"
            data-automation-id="link-browse-by-international"
            (click)="scrollTo('browse-international')"
          >
            <span>Browse International Facilities</span>
          </a>
        </div>
        <div class="d-flex align-items-start align-items-xl-center mb-8">
          <digital-platform-rsx-a
            class="small fw-semibold d-block"
            klass="text-decoration-none"
            url="/customer-support/facilities"
          >
            <span>Need a Residential or Business Facility Instead?</span>
          </digital-platform-rsx-a>
          <digital-platform-icon
            icon="arrow-forward"
            color="secondary"
            class="ms-6 ms-xl-4"
          ></digital-platform-icon>
        </div>
      </div>
      <div class="d-none d-xl-flex justify-content-between">
        <small class="d-block mb-4" data-automation-id="results-text">
          {{ filteredFacilities.length }} results
        </small>
        <digital-platform-facility-filter-service
          [availableServices]="availableServices"
          (updateSelectedServices)="updateSelectedServices($event)"
          [selectedServices]="selectedServiceNames"
          #facilityFilterService
        ></digital-platform-facility-filter-service>
      </div>
      <digital-platform-facility-results
        [facilities]="filteredFacilities"
        [serviceBadgesHeight]="serviceBadgesHeight"
        class="d-none d-xl-block"
        data-automation-id="digital-platform-results"
      ></digital-platform-facility-results>
    </div>
  </div>
  <div class="facilities-map-container" *ngIf="facilities$">
    <digital-platform-bing-map
      [pushpins]="facilities$ | async"
      [filteredPushpins]="filteredFacilities"
      [stateKey]="stateKey"
      (updateFilter)="pushpinCoordinates$.next($event)"
    ></digital-platform-bing-map>
  </div>
</section>
<div class="d-none d-xl-flex justify-content-center mt-xl-8 ms-xl-18">
  <digital-platform-icon
    (click)="scrollTo()"
    icon="chevron-down-circle"
    data-automation-id="button-scroll-browse-by-state"
    style="cursor: pointer"
    [height]="40"
    [width]="40"
  ></digital-platform-icon>
</div>

<ng-container *ngIf="facilities$">
  <digital-platform-facility-tabs
    [stateKey]="stateKey"
    [facilities]="facilities$ | async"
    [filteredFacilities]="filteredFacilities"
    [availableServices]="availableServices"
    [selectedServices]="selectedServiceNames"
    [serviceBadgesHeight]="serviceBadgesHeight"
    (updateSelectedServices)="updateSelectedServices($event)"
    (updateMapFilter)="pushpinCoordinates$.next($event)"
    data-automation-id="digital-platform-facility-tabs"
    class="d-block d-xl-none"
  ></digital-platform-facility-tabs>
</ng-container>

<digital-platform-filter-by-location
  class="d-block mt-9 pt-3 browse-states"
  header="Browse Facilities By State"
  [height]="404"
  [locations]="usaLocations"
  data-automation-id="facility-filter-state"
></digital-platform-filter-by-location>
<div class="browse-international d-block d-xl-flex"></div>
<digital-platform-filter-by-location
  class="d-block mb-12"
  header="Browse International Facilities"
  [height]="260"
  [locations]="intlLocations"
  data-automation-id="facility-filter-international"
></digital-platform-filter-by-location>
